import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery , takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import * as Api from 'api';

/***************************** Selectors ************************************/

/***************************** Subroutines ************************************/

function routineFactory(actionName) {
  return function *({ payload }) {
    try {
      const apiCall = Api[actionName];
      if(!apiCall) {
        return console.warn(`There is no Api.${actionName}() available.`);
      }

      const result = yield apiCall(payload, payload && payload._id);
      const successActionName = `${actionName}Success`;
      const actionCreator = Actions[successActionName];
      if(!actionCreator) {
        return console.warn(`There is no Actions.${successActionName}() available.`);
      }

      yield put(actionCreator(result));
    }
    catch(ex) {
      const failureActionName = `${actionName}Failed`;
      const actionCreator = Actions[failureActionName];
      if(!actionCreator) {
        return console.warn(`There is no Actions.${failureActionName}() available.`);
      }
      yield put(actionCreator(ex));
    }
  }
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function * salesSiteManagerWatcher() {
  return yield * [
    takeLatest(ActionTypes.PAGE_FETCH, routineFactory('fetchPages')),
    takeLatest(ActionTypes.PAGE_CREATE, routineFactory('createPage')),
    takeLatest(ActionTypes.PAGE_UPDATE, routineFactory('updatePage')),
    takeLatest(ActionTypes.PAGE_DELETE, routineFactory('deletePage')),
    takeLatest(ActionTypes.PAGE_TEMPLATE_FETCH, routineFactory('fetchPageTemplates')),
    takeLatest(ActionTypes.PAGE_TEMPLATE_CREATE, routineFactory('createPageTemplate')),
    takeLatest(ActionTypes.PAGE_TEMPLATE_UPDATE, routineFactory('updatePageTemplate')),
    takeLatest(ActionTypes.PAGE_TEMPLATE_DELETE, routineFactory('deletePageTemplate')),
    takeLatest(ActionTypes.SECTION_FETCH, routineFactory('fetchSections')),
    takeLatest(ActionTypes.SECTION_CREATE, routineFactory('createSection')),
    takeLatest(ActionTypes.SECTION_UPDATE, routineFactory('updateSection')),
    takeLatest(ActionTypes.SECTION_DELETE, routineFactory('deleteSection')),
    takeLatest(ActionTypes.SECTION_TEMPLATE_FETCH, routineFactory('fetchSectionTemplates')),
    takeLatest(ActionTypes.SECTION_TEMPLATE_CREATE, routineFactory('createSectionTemplate')),
    takeLatest(ActionTypes.SECTION_TEMPLATE_UPDATE, routineFactory('updateSectionTemplate')),
    takeLatest(ActionTypes.SECTION_TEMPLATE_DELETE, routineFactory('deleteSectionTemplate')),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/sales-site-manager.js